module.exports = __webpack_public_path__ + "img/GDQ-Associates-White.1a21076e.svg";